<template>
  <div v-if="branch?.address" class="flex items-start gap-2 md:block">
    <div class="flex-1">
      <p>{{ branch.address }}</p>
      <p v-if="branch.location_detail" class="mt-1 text-sm text-gray-80">{{ branch.location_detail }}</p>
      <copy-address-button class="mt-2 md:mb-4" :address="branch.address" :text="$t('branch_detail.about.copy_address')" />
    </div>
    <map-link
      v-if="appStore.isMobileScreen"
      class="size-15 md:hidden"
      icon="map-geo"
      :address="branch.locale_address || branch?.address"
      :place-id="branch.google_place_id"
    />
    <div v-else-if="iframeMapTarget" class="py-4 hidden md:block">
      <iframe-map :target="iframeMapTarget" :latitude="branch.lat" :longitude="branch.lng" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import MapLink from '@/components/common/map-link.vue'
import IframeMap from '@/components/common/iframe-map.vue'
import CopyAddressButton from '@/components/common/copy-address-button.vue'

import { useAppStore } from '@/store/app'

const appStore = useAppStore()

const { branch } = useBranchDetailContext()
const iframeMapTarget = computed(() => {
  if (branch.value?.google_place_id) {
    return `place_id:${branch.value.google_place_id}`
  }
  return branch.value?.locale_address || branch.value?.address
})
</script>
